import { useState } from "react";

import { useHistory } from "react-router";

import { FeatureFlags, useFeatureEnabled } from "~/v2/helpers/featureFlags";
import { useGetIraAccountOwnerSummary } from "src/v2/api/hooks/useGetIRA";
import { Path } from "src/v2/path";
import { useAccountContext } from "src/v2/providers/AccountProvider";
import {
  IRAContributionCardLoading,
  IRAContributionCardPres,
} from "./IRAContributionCard.pres";

const CURRENT_YEAR = new Date().getFullYear().toString();

export const IRAContributionCardConnector = () => {
  const history = useHistory();

  const [taxYear, setTaxYear] = useState(CURRENT_YEAR);
  const { currentAccount, liveAccounts } = useAccountContext();
  if (!currentAccount) {
    throw new Error(
      "This component cannot be rendered without a current account",
    );
  }

  const isIraAccount = currentAccount?.account_type === "ira";
  const iraAccounts = liveAccounts.filter((a) => a.account_type === "ira");
  const hasBothTypes =
    iraAccounts.some((a) => a.account_sub_type === "traditional") &&
    iraAccounts.some((a) => a.account_sub_type === "roth");

  const {
    ytdAccountContributionAmount,
    ytdOverallContributionAmount,
    ownerAnnualContributionLimit,
    ytdAccountContributionPercent,
    overcontributionAmount,
    lifetimeOverallContributionAmount,
    availableTaxYears,
    isLoading,
  } = useGetIraAccountOwnerSummary({ currentAccount, taxYear });

  const isIRAContributionsEnabled = useFeatureEnabled(
    FeatureFlags.IRA_CONTRIBUTIONS_CARD,
  );

  if (!isIraAccount || !isIRAContributionsEnabled) {
    return null;
  }

  if (isLoading) {
    return <IRAContributionCardLoading />;
  }

  return (
    <IRAContributionCardPres
      currentType={currentAccount.account_sub_type ?? ""}
      hasBothTypes={hasBothTypes}
      ytdAccountContributionAmount={ytdAccountContributionAmount}
      ytdOverallContributionAmount={ytdOverallContributionAmount}
      ownerAnnualContributionLimit={ownerAnnualContributionLimit}
      lifetimeOverallContributionAmount={lifetimeOverallContributionAmount}
      overcontributionAmount={overcontributionAmount}
      ytdAccountContributionPercent={ytdAccountContributionPercent}
      currentYear={CURRENT_YEAR}
      taxYear={taxYear}
      availableTaxYears={availableTaxYears}
      onClickAddContribution={() => history.push(Path.ROUTE_FUNDING_DEPOSIT)}
      onClickTaxYear={(year) => setTaxYear(year)}
    />
  );
};
